import { useEffect, useMemo } from "react";
import { useProject } from "../stores/useProject";
import { useProfile } from "../stores/useProfile";
import { useInvoice } from "../stores/useInvoice";
import { useQuote } from "../stores/useQuote";

export const DataLoader = () => {
  const { fetchProjects } = useProject();
  const { fetchInvoices } = useInvoice();
  const { fetchQuotes } = useQuote();
  const { user } = useProfile();

  const data = useMemo(async () => {
    if (!user) return;

    await fetchProjects(user);
    await fetchInvoices(user);
    await fetchQuotes(user);
  }, [user]);

  return <></>;
};
